module.exports = __webpack_public_path__ + "static/media/Engxg3.80c3be35.png";